var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0537 1.97949V5.27932H15.7539",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7874 9.29308C21.2637 9.46767 20.9858 10.0331 21.1049 10.5722C21.7933 13.688 20.9257 17.0784 18.502 19.502C14.727 23.2771 8.60637 23.2771 4.8313 19.502C1.05623 15.727 1.05623 9.60637 4.8313 5.8313C8.36799 2.29461 13.9633 2.07129 17.76 5.16133C18.1884 5.50995 18.8186 5.51472 19.2091 5.12419C19.5997 4.73367 19.6017 4.09625 19.1796 3.74014C14.5958 -0.126587 7.73511 0.0990624 3.41709 4.41709C-1.13903 8.97321 -1.13903 16.3601 3.41709 20.9162C7.9732 25.4724 15.3601 25.4724 19.9162 20.9162C22.8932 17.9393 23.925 13.7537 23.0117 9.93894C22.883 9.40142 22.3118 9.1183 21.7874 9.29308Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.00e50961c379a6604c560f3e18a9e2ba.svg";
export { ForwardRef as ReactComponent };